import { Settings2 } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { SettingsPage } from './pages/SettingsPage'

/**
 * Settings — M10. First Admin archetype (spec §Archetype 6).
 *
 * Nested section nav: Users & Roles · CofA Notifications · Integrations
 * · System Health. Gated to admin only at the manifest level — the
 * shell router redirects non-admin users to /_403 on direct URL access.
 */
export default defineModule({
  id: 'settings',
  name: 'Settings',
  shortName: 'Settings',
  icon: Settings2,
  navSection: 'admin',
  navOrder: 90,
  urlNamespace: '/settings',
  routes: [{ path: '/', element: SettingsPage, label: 'Settings' }],
  permissions: ['admin'],
  densityDefault: 'comfortable',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s',

  commandPaletteEntries: [
    {
      label: 'Go to Settings',
      keywords: ['settings', 'admin', 'users', 'roles', 'subscribers', 'health'],
      path: '/',
      group: 'modules',
      shortcut: 'g s',
    },
  ],
})
